import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { SubscriptionManagementService } from '@App/pages/pricing/services/subscription-management.service';
import { map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
class ProPlusValidation {
  constructor(
    private subscriptionManagementService: SubscriptionManagementService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.subscriptionManagementService.getCurrentPlan().pipe(
      take(1),
      map((plan) => {
        if (!plan) {
          this.router.navigate(['/pricing']).then();
          return false;
        }

        const familyId = plan.familyId || plan.package || '';
        const isProPlus = familyId.toLowerCase() === 'pro-plus';

        if (!isProPlus) {
          this.router.navigate(['/pricing']).then();
          return false;
        }

        return true;
      })
    );
  }
}

export const ProPlusValidationGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(ProPlusValidation).canActivate(next, state);
};
